import { render, staticRenderFns } from "./jak-kupic-niemieckie-akcje.md?vue&type=template&id=a39e69d0&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports